<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4375 18.8219H13.5875V18.6719V9.45312C13.5875 8.84456 14.0789 8.35313 14.6875 8.35313H35.7812C36.3898 8.35313 36.8812 8.84456 36.8812 9.45312V20.0781C36.8812 20.6867 36.3898 21.1781 35.7812 21.1781H26.5625H26.4125V21.3281V30.5469C26.4125 31.1554 25.9211 31.6469 25.3125 31.6469H4.21875C3.61019 31.6469 3.11875 31.1554 3.11875 30.5469V19.9219C3.11875 19.3133 3.61019 18.8219 4.21875 18.8219H13.4375ZM16.0938 10.7094H15.9438V10.8594V18.6719V18.8219H16.0938H23.9062H24.0562V18.6719V10.8594V10.7094H23.9062H16.0938ZM13.4375 29.2906H13.5875V29.1406V21.3281V21.1781H13.4375H5.625H5.475V21.3281V29.1406V29.2906H5.625H13.4375ZM23.9062 29.2906H24.0562V29.1406V21.3281V21.1781H23.9062H16.0938H15.9438V21.3281V29.1406V29.2906H16.0938H23.9062ZM34.375 18.8219H34.525V18.6719V10.8594V10.7094H34.375H26.5625H26.4125V10.8594V18.6719V18.8219H26.5625H34.375Z"
      fill="var(--livi-primary)"
      stroke="white"
      stroke-width="0.3"
    />
  </svg>
</template>
